import React, { useState, useEffect, useContext } from "react";
import { User, Phone, Mail } from "lucide-react";
import Navbar from "../components/Navbar";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const LabProfile = () => {
  const {
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const [lab, setLab] = useState(null);

  const getLabDetails = async () => {
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/chemist_profile", // Replace with your actual endpoint
        {},
        { headers: headersList }
      );

      if (response.status === 200) {
        console.log(response.data);
        setLab(response.data?.lab_details || {});
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data.detail === "Token has expired"
      ) {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  useEffect(() => {
    getLabDetails();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 to-white">
      <Navbar />
      <div className="max-w-2xl mx-auto p-6 mt-6">
        <div className="bg-white rounded-3xl shadow-xl p-6 space-y-4">
          {!lab ? (
            <p className="text-center text-gray-500">Loading lab details...</p>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-blue-800 flex items-center gap-3">
                <User className="w-6 h-6" />
                {lab.lab_name || <span className="text-gray-400">Lab Name Not Provided</span>}
              </h2>

              <div className="space-y-4 text-gray-700 text-sm">
                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-green-500" />
                  {lab.phone_no || <span className="text-gray-400">Phone Not Provided</span>}
                </p>
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-blue-500" />
                  {lab.lab_email || <span className="text-gray-400">Email Not Provided</span>}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LabProfile;
